import script from "./BaseFile.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFile.vue?vue&type=script&setup=true&lang=js"

import "./BaseFile.vue?vue&type=style&index=0&id=bde67822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bde67822"]])

export default __exports__